import React from "react";
import { classnames as cx, withState } from "@mna/react";
import { Trans } from "react-i18next";
import terms from "assets/img/terms.png";
import LoadingScreen from "features/LoadingScreen";
import { setUser } from "../../App/TelemetryService";
import {
  checkAndGetLocalStorageValue,
  checkUrlSearchParamsHas,
  getUrlSearchParamsValue,
} from "../../features/utils";
import i18next from "i18next";
import { gemOrgId } from "../../client.config";

const Terms = ({ setState, actions, state, history }) => {
  function checkBox() {
    var check = document.getElementById("cbTnC");
    var btnCtn = document.getElementById("btnContinue");
    if (check.checked) {
      setState({ item: true });
      check.setAttribute('aria-checked', 'true');
      btnCtn.setAttribute('aria-disabled', 'false');
      btnCtn.tabIndex = "0";
    } else {
      setState({ item: false });
      check.setAttribute('aria-checked', 'false');
      btnCtn.setAttribute('aria-disabled', 'true');
      btnCtn.tabIndex = "-1";
    }
    if (state.isTravelAid2) {
      setState({ RelatedSymptomInfo: "", isEmrgencyAnswerAdded: false });
    }
  }
  if (state.isLoading_Terms) {
    setState({ isLoading_Terms: false });
  }
  return (
    <LoadingScreen isLoading={state.isLoading}>
      <div className="page-section-1">
        <div className="container-2 w-container">
          <div className="w-row">
            <div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
            <div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack column-2-with-banner">
              <h1 className="heading">
                <Trans i18nKey="getstartModal.msg15">
                  Before you find the right care
                </Trans>
              </h1>
              <span>
                <h2 className="mb-0 !important">
                  <Trans i18nKey="getstartModal.msg_2"> Remember that:</Trans>
                </h2>
                <br />
                <h3 className="mb-0 !important">
                  <Trans i18nKey="getstartModal.msg3bold">
                    Triage is not a diagnosis
                  </Trans>{" "}
                </h3>
                <Trans i18nKey="getstartModal.msg3">
                  Triage is for informational purposes and is not a qualified
                  medical opinion.
                </Trans>
                <h3 className="mb-0 !important">
                  <Trans i18nKey="getstartModal.msg4bold">
                    Do not use in emergencies.
                  </Trans>
                </h3>
                <Trans i18nKey="getstartModal.msg4">
                  In case of health emergency, call your local emergency number
                  immediately.
                </Trans>
                <h3 className="mb-0 !important">
                  <Trans i18nKey="getstartModal.msg5bold">
                    A referral does not constitute coverage.
                  </Trans>{" "}
                </h3>
                <Trans i18nKey="getstartModal.msg5">
                  Claim coverage is determined by insurance carrier and not this
                  tool. Nor is adherence to the recommended level of treatment
                  mandatory to ensure coverage under your policy.
                </Trans>{" "}
                <h3 className="mb-0 !important">
                  <Trans i18nKey="getstartModal.msg6bold">
                    Your data is safe.
                  </Trans>
                </h3>
                <Trans i18nKey="getstartModal.msg6">
                  Information that you provide is protected pursuant to the
                  terms of our privacy policy. We only process information for
                  the purposes as outlined in the Privacy Policy below.
                </Trans>
              </span>
              <div className="w-form">
                <div className="checkbox-Style">
                  <div className="w-checkbox checkbox-field">
                    <input
                      type="checkbox"
                      id="cbTnC"
                      name="cbTnC"
                      role="checkbox" 
                      aria-label="Terms and Conditions checkbox"
                      data-name="Checkbox"
                      className="w-checkbox-input check"
                      onClick={checkBox}
                      onKeyUp={(e) => {
                        if (e.key === "Enter"){
                          e.target.click();
                          checkBox();
                        }
                      }}
                    />
                  </div>
                  <label className="w-form-label" htmlFor="cbTnC">
                    <Trans i18nKey="getstartModal.msg12">
                      I read and accept 
                    </Trans>
                    <strong>
                      <a
                        href="#"
                        onClick={() => {window.open(state.terms, '_blank');}}
                        onKeyDown={(e) => {
                          if (e.key === " " || e.key === "Spacebar"){
                            window.open(state.terms, '_blank');
                          }
                        }}
                      >
                        {i18next.t("getstartModal.msg1")}
                        {/* <Trans i18nKey="getstartModal.msg1">
                          Terms of Service
                        </Trans> */}
                      </a>
                    </strong>
                    <Trans i18nKey="getstartModal.msg13">and</Trans>
                    <strong>
                      <a
                        href="#"
                        onClick={() => {window.open(state.privacy, '_blank');}}
                        onKeyDown={(e) => {
                          if (e.key === " " || e.key === "Spacebar"){
                            window.open(state.privacy, '_blank');
                          }
                        }}
                      >
                        {i18next.t("footer.privacy")}
                        {/* <Trans i18nKey="footer.privacy">Privacy Policy</Trans> */}
                      </a>
                    </strong>
                    <Trans i18nKey="getstartModal.msg14">
                      {" "}
                      and consent to the collection and processing of my data
                      for the purpose of accessing this service
                    </Trans>
                  </label>
                </div>
                <div className="continue-btn">
                  <button
                    type="submit"
                    id="btnContinue"
                    tabIndex="0"
                    className={cx(
                      state.item &&
                        (state.IsValidUser ||
                          state.azure.accessToken != null) &&
                        state.IsOrgSubscriptionValid &&
                        state.IsUserSubscriptionValid
                        ? "btn button1 standby-button-gradient standby-button-gradient-blue"
                        : "btn button1 disabled standby-button-gradient standby-button-disabled"
                    )}
                    disabled={state.item &&
                      (state.IsValidUser ||
                        state.azure.accessToken != null) &&
                      state.IsOrgSubscriptionValid &&
                      state.IsUserSubscriptionValid ? false : true}
                    onClick={(e) => {
                      if (
                        state.item &&
                        (state.IsValidUser ||
                          state.azure.accessToken != null) &&
                        state.IsOrgSubscriptionValid &&
                        state.IsUserSubscriptionValid
                      ) {
                        if (sessionStorage.getItem("IsValidUser") !== "true") {
                          setUser.setUserIdAction(
                            checkAndGetLocalStorageValue("userEmail"),
                            checkAndGetLocalStorageValue("orgid")
                          );
                        }

                        setState({
                          item: false,
                          enteredStartName: "",
                          enteredStartPolicy: "",
                          enteredStartTravelFrom: "",
                          enteredStartTravelTo: "",
                          isMenuClick: true,
                        });
                        e.preventDefault();
                        actions.clearTriageSession();
                        history.push("/find-care-options");
                      }
                      gtag(
                        "set",
                        "content_group",
                        checkAndGetLocalStorageValue("orgid")
                      );
                    }}
                  >
                    <Trans i18nKey="findcareoption.Covid.Continue_text">
                      Continue
                    </Trans>
                  </button>
                </div>
              </div>
            </div>
            <div className="w-col w-col-6 w-col-tiny-tiny-stack">
              <img
                src={terms}
                loading="lazy"
                data-w-id="472c584b-76c4-b0fb-965d-c82468fbcd15"
                alt=""
                className="t-img"
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingScreen>
  );
};

export default withState({
  async didMount({ state, setState, actions, history }) {
    localStorage.setItem("careoption", "");
    if (state.IsValidUser === undefined || !state.IsValidUser) {
      setState({
        isTriageGoingForRegularUser: true,
      });
    }
    if (checkUrlSearchParamsHas(window.location.search)) {
      setState({
        isLoading: true,
      });
      var organizationId = getUrlSearchParamsValue(window.location.search);
      localStorage.setItem("orgid", organizationId);
      if(checkAndGetLocalStorageValue("orgid") === gemOrgId){
         setState({
          isCallCenter: true,
          });
        }

      await actions.validateOrganizationDetails(
        state,
        setState,
        actions,
        history,
        organizationId
      );
    }
  },
})(Terms);
